module.exports = __webpack_public_path__ + "img/img-d637b7c2.2418a928.png";